module.exports = __webpack_public_path__ + "img/CherryChainLogo.a673ba4e.png";